import React from 'react';
import { useTranslation } from 'react-i18next';
import { toHoursAndMinutes } from '../../utils/time';

const SabotageComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.sabotage_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          {report.sabotage_type && (
            <tr>
              <th>Type</th>
              <td>{t(`sabotage.${report.sabotage_type.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.road && (
            <tr>
              <th>Road Access</th>
              <td>{t(`sabotage.${report.road.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.rail && (
            <tr>
              <th>Impacted</th>
              <td>{t(`sabotage.${report.rail.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.rail_operational && (
            <tr>
              <th>Operational</th>
              <td>{t(`sabotage.${report.rail_operational.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.power && (
            <tr>
              <th>Impact</th>
              <td>{t(`sabotage.${report.power.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.power_outage_duration > 0 && (
            <tr>
              <th>Duration</th>
              <td>{toHoursAndMinutes(report.power_outage_duration)}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SabotageComponent;
